export default function cancelClassErrorMessage(e) {
  const errors = e.response?.data?.errors;
  if (Array.isArray(errors)) return errors[0] || "Could not cancel class.";
  return errors?.cancellation_reason?.[0] || errors?.base?.[0] || "Could not cancel class.";
}
